import React from "react";
import companyLogo from "../../assets/4.png";
import edsx from "../../assets/edsx_white.png";
import { Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="bg-dark1">
      <Row className="p-2 px-3 align-items-center g-2">
        <Col
          xs="12"
          md="6"
          className="text-light text-center text-md-start small"
        >
          © 2023 New Era Goldchain Sagl, via Francesco Soave, 1, Lugano,
          CHE-327.742.320
        </Col>
        <Col
          xs="12"
          md="6"
          className="d-flex flex-column flex-sm-row justify-content-center justify-content-md-end align-items-center text-center text-sm-start gap-2"
        >
          <div className="d-flex align-items-center">
            <img
              src={edsx}
              alt="EDSX"
              style={{ height: "auto", maxWidth: "100px" }}
              className="img-fluid"
            />
            <img
              src={companyLogo}
              alt="Swiss Innovation Hub"
              className="ms-2 img-fluid"
              style={{ height: "auto", maxWidth: "80px" }}
            />
          </div>
          <p className="mb-0 small">
            Realized by{" "}
            <a
              href="https://www.swissinnovationhub.ch"
              target="_blank"
              rel="noreferrer"
              className="text-gold text-decoration-none"
            >
              Swiss Innovation Hub
            </a>{" "}
            <br className="d-none d-sm-inline" /> in collaboration with{" "}
            <a
              href="https://www.edsx.ch"
              target="_blank"
              rel="noreferrer"
              className="text-gold text-decoration-none"
            >
              EDSX
            </a>
          </p>
        </Col>
      </Row>
    </footer>
  );
};
export default Footer;
